var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPhone(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2544 2.52816L13.1864 0.462136C13.0405 0.315619 12.8671 0.199367 12.6762 0.120059C12.4853 0.0407514 12.2805 -4.95526e-05 12.0738 4.51641e-08C11.6524 4.51641e-08 11.2563 0.165049 10.9592 0.462136L8.73398 2.68738C8.58746 2.83325 8.47121 3.00664 8.3919 3.19758C8.3126 3.38852 8.27179 3.59325 8.27184 3.8C8.27184 4.22136 8.43689 4.61748 8.73398 4.91456L10.3612 6.54175C9.98028 7.38128 9.45072 8.14503 8.79806 8.79612C8.14703 9.45037 7.38335 9.98185 6.54369 10.365L4.91651 8.73786C4.77063 8.59135 4.59724 8.4751 4.4063 8.39579C4.21536 8.31648 4.01064 8.27568 3.80388 8.27573C3.38252 8.27573 2.98641 8.44078 2.68932 8.73786L0.462137 10.9612C0.31544 11.1073 0.199088 11.281 0.119777 11.4723C0.0404652 11.6636 -0.000240619 11.8687 1.06997e-06 12.0757C1.06997e-06 12.4971 0.16505 12.8932 0.462137 13.1903L2.52621 15.2544C3 15.7301 3.65437 16 4.32621 16C4.46796 16 4.60388 15.9883 4.73786 15.965C7.35534 15.534 9.95146 14.1417 12.0466 12.0485C14.1398 9.95728 15.5301 7.36311 15.967 4.73786C16.099 3.93592 15.833 3.11068 15.2544 2.52816Z",
    fill: "#0859A4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic-phone.4889b885.svg";
export { ForwardRef as ReactComponent };